import * as React from 'react';
import { Form, Grid, Segment } from 'semantic-ui-react';

import { FormaDePagoId } from 'src/modulos/Matriculas/IngresoNuevaMatricula/tipos';
import Cheque, { Datos as ChequeDatos, inicial as chequeInicial } from './componentes/Cheque';
import Contado, { Datos as ContadoDatos, inicial as contadoInicial } from './componentes/Contado';
import Pagare, { Datos as PagareDatos, inicial as pagareInicial } from './componentes/Pagare';
import Tarjeta, { Datos as TarjetaDatos, inicial as tarjetaInicial } from './componentes/Tarjeta';

export interface Datos {
    forma: FormaDePagoId;
    contado: ContadoDatos;
    cheque: ChequeDatos;
    pagare: PagareDatos;
    tarjeta: TarjetaDatos;
}

export const inicial: Datos = {
    forma: 'contado',
    contado: { ...contadoInicial },
    cheque: { ...chequeInicial },
    pagare: { ...pagareInicial },
    tarjeta: { ...tarjetaInicial },
};

export interface Props {
    formasPago: Datos;
    onChange(formasPago: Datos): void;
    alCambiarFormaDePago(forma: string): void;
}

interface State {}

class FormasPago extends React.Component<Props, State> {
    public state: State = {
        listaEntidadesCheques: [],
        listaEntidadesTarjetaCredito: [],
        listaEntidadesTarjetaDebito: [],
        listaEntidadesTransferencia: [],
    };

    public render() {
        const { formasPago, onChange, alCambiarFormaDePago } = this.props;

        let componente = null;
        switch (formasPago.forma) {
            case 'contado': {
                componente = <Contado />;
                break;
            }

            case 'cheque': {
                componente = (
                    <Cheque
                        cheque={formasPago.cheque}
                        onChange={cheque => {
                            onChange({ ...formasPago, cheque });
                        }}
                    />
                );
                break;
            }

            case 'pagare': {
                componente = (
                    <Pagare
                        pagare={formasPago.pagare}
                        onChange={pagare => {
                            onChange({ ...formasPago, pagare });
                        }}
                    />
                );
                break;
            }

            case 'tarjeta': {
                componente = (
                    <Tarjeta
                        tarjeta={formasPago.tarjeta}
                        onChange={tarjeta => {
                            onChange({ ...formasPago, tarjeta });
                        }}
                    />
                );
                break;
            }

            default:
                componente = null;
        }

        return (
            <Segment style={{ minHeight: '291px' }}>
                <Grid stackable>
                    <Grid.Column computer='4' largeScreen='6'>
                        <Form.Select
                            label='Forma de pago'
                            placeholder='Seleccione'
                            options={[
                                { value: 'contado', text: 'Contado' },
                                { value: 'tarjeta', text: 'Tarjeta' },
                                { value: 'cheque', text: 'Cheque' },
                                { value: 'pagare', text: 'Pagaré' },
                            ]}
                            value={formasPago.forma}
                            onChange={(_e, { value }) => {
                                alCambiarFormaDePago(value as string);
                            }}
                        />
                    </Grid.Column>

                    <Grid.Column computer='12' largeScreen='10'>
                        {componente}
                    </Grid.Column>
                </Grid>
            </Segment>
        );
    }
}

export default FormasPago;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/FormasPago/index.tsx